document.addEventListener('click',function(e){if(e.target.matches('.bv-frequency button')){e.target.parentElement.querySelectorAll('button').forEach(function(b){b.classList.remove('active')});e.target.classList.add('active')}});
document.addEventListener('change',function(event){if(!event.target.matches('[data-bv-kit-select]'))return;var card=event.target.closest('[data-bv-kit]');var contents=card.querySelector('[data-bv-kit-contents]');contents.textContent=event.target.value;});

document.addEventListener('click',function(event){
 var link=event.target.closest('.bv-mobile-menu a');
 if(link){var menu=link.closest('details');menu.open=false;}
});
document.addEventListener('keydown',function(event){
 if(event.key==='Escape'){document.querySelectorAll('.bv-mobile-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}
});

document.addEventListener('click',function(event){
 var link=event.target.closest('[data-bv-format]');
 if(!link)return;
 var index=link.dataset.bvFormat==='ground'?0:1;
 document.querySelectorAll('[data-bv-kit-select]').forEach(function(select){
  select.selectedIndex=index;
  var contents=select.closest('[data-bv-kit]').querySelector('[data-bv-kit-contents]');
  if(contents)contents.textContent=select.value;
 });
});

(function(){
 var mobile=window.matchMedia('(max-width:760px)');
 function syncDisclosures(){document.querySelectorAll('[data-bv-mobile-disclosure]').forEach(function(details){details.open=!mobile.matches;});}
 if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',syncDisclosures);}else{syncDisclosures();}
 if(mobile.addEventListener)mobile.addEventListener('change',syncDisclosures);
 document.addEventListener('click',function(event){
  var link=event.target.closest('a[href^="#"]');
  if(!link)return;
  var target=document.getElementById(link.getAttribute('href').slice(1));
  if(!target)return;
  var parent=target.closest('[data-bv-mobile-disclosure]');
  if(parent)parent.open=true;
 });
})();

(function(){
 function initLaunchForm(){
  var feedback=document.getElementById('bv-email-success')||document.getElementById('bv-email-error');
  if(feedback && feedback.textContent.trim()){feedback.focus({preventScroll:true});}
  var form=document.getElementById('bv-launch-form');
  if(!form)return;
  form.addEventListener('submit',function(){var button=form.querySelector('button[type="submit"]');if(button){button.textContent='Submitting…';button.setAttribute('aria-busy','true');}});
  document.querySelectorAll('.bv-launch-notify,.bv-subscription-notify').forEach(function(link){link.addEventListener('click',function(){var input=document.getElementById('bv-newsletter-email');if(input)input.focus({preventScroll:true});});});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initLaunchForm);else initLaunchForm();
})();
